module.exports = __webpack_public_path__ + "static/bg-science-b9e92c1e997381df291c80f60409bcce.jpg";